/** A failure, with what to do about it underneath. */
import { describeError } from "../lib/errors";

export function ErrorNotice({
  error,
  fallback = "Something went wrong.",
}: {
  error: unknown;
  fallback?: string;
}) {
  if (!error) return null;
  const { message, nextStep } = describeError(error, fallback);
  return (
    <div className="notice error" role="alert">
      <strong>{message}</strong>
      {nextStep && <span className="next-step">{nextStep}</span>}
    </div>
  );
}
